import { useGLTF, useAnimations } from "@react-three/drei";
import { useEffect } from "react";

import {
  Animation3DInteractionType,
  BaseAnimationWithAssetProps,
  KeyFrameAnimationType,
  InteractionPlaybackOptions3D,
} from "../../types";
import { playbackActionToThreePlaybackAction } from "../utils";

export type Props = BaseAnimationWithAssetProps &
  KeyFrameAnimationType &
  Animation3DInteractionType;

const KeyFrameAnimationWithAsset: React.FC<Props> = ({
  asset,
  transform3D,
  interactionType,
  actionName,
  playbackAction,
}) => {
  const { scene, animations } = useGLTF(asset.url);
  const { actions } = useAnimations(animations, scene);

  const shouldAutoplay =
    interactionType === InteractionPlaybackOptions3D.autoplay;

  useEffect(() => {
    actions[actionName]?.setLoop(
      playbackActionToThreePlaybackAction[playbackAction],
      1,
    );

    if (shouldAutoplay) actions[actionName]?.play();
  }, []);

  const props = shouldAutoplay
    ? undefined
    : {
        [interactionType]: () => {
          // we want the animation to restart
          // everytime the interaction occurs
          actions[actionName]?.reset();
          actions[actionName]?.play();
        },
      };

  return (
    <group>
      <primitive
        {...props}
        object={scene}
        position={transform3D?.position}
        rotation={transform3D?.rotation}
        scale={transform3D?.scale}
      />
    </group>
  );
};

export default KeyFrameAnimationWithAsset;
